import type { LookupCodeApi, LookupCodeListApi, LookupCodeOption, LookupCodeOptions } from '../../models';

const normalizeLookupCodeOption = (lookupCode: LookupCodeApi): LookupCodeOption => ({
  id: String(lookupCode.id),
  label: lookupCode.codeDesc ?? '',
  value: String(lookupCode.codeId),
});

export const normalizeLookupCodeOptions = (list: LookupCodeListApi): LookupCodeOptions => {
  const options = list?.items.map(normalizeLookupCodeOption);
  return {
    list: options,
    map: options.reduce(
      (acc, option) => {
        acc[option.id] = option;
        return acc;
      },
      {} as LookupCodeOptions['map'],
    ),
  };
};
